import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-gray-900"
}
const _hoisted_2 = {
  key: 1,
  class: "text-gray-400"
}

import RowLink from '@/components/neue/RowLink.vue'


export default {
  __name: 'SmartListLinks',
  props: { lists: { type: Array, default: () => [] } },
  setup(__props) {



return (_ctx, _cache) => {
  return (__props.lists.length)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lists, (list) => {
          return (_openBlock(), _createElementBlock("span", {
            key: list.id,
            class: "smart-list"
          }, [
            _createVNode(RowLink, {
              to: '/lists/' + list.id,
              text: list.name
            }, null, 8, ["to", "text"])
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
}
}

}